
import combinatorics from '../../../../helpers/combinatorics'

export default function Decision(R){
	const classNames = {
		c_7c73ff: 'c_7c73ff',
		c_229e6d: 'c_229e6d',
		c_cc8b1e: 'c_cc8b1e',
		c_006dfe: 'c_006dfe',
		c_ff33ff: 'c_ff33ff',
		c_ff0000: 'c_ff0000',
		b_f8aa46: 'ball b_f8aa46',
		b_4c8bda: 'ball b_4c8bda',
		b_008000: 'ball b_008000',
		b_ff0000: 'ball b_ff0000',
		c_f95016: 'c_f95016',
		c_476efe: 'c_476efe',
		c_fc5d50: 'c_fc5d50',
		c_1291bb: 'c_1291bb',
		c_0b9fb9: 'c_0b9fb9'
	}
	return [
		// 组选
		{
			priority: 80000,
			condition: function(R) {
		    R.when( _.includes(this.ruleSuite.rules, 'GROUP') );
		  },
		  consequence: function(R) {
		  	_.each(this.historyCodes, function(history){
		  		const unionWorkCode = _.union(history.workCode).length;
		  		const groupBySize = _.filter(_.groupBy(history.workCode), (item) => item.length > 1).length;
		  		if(history.code==''){
		  			history.form.push({label: '--',className: classNames.c_ff0000})
		  		}
		  		switch(history.workCode.length){
		  			// 五星
		  			case 5: {
		  				this.title = '五星组态';
		  				if (unionWorkCode === 5) {
		  					history.form.push({label: '组选120',className: classNames.c_7c73ff})
		  				}
		  				if (unionWorkCode === 4) {
		  					history.form.push({label: '组选60',className: classNames.c_1291bb})
		  				}
		  				if (unionWorkCode === 3 && groupBySize === 2) {
		  					history.form.push({label: '组选30',className: classNames.c_229e6d})
		  				}
		  				if (unionWorkCode === 3 && groupBySize === 1) {
		  					history.form.push({label: '组选20',className: classNames.c_cc8b1e})
		  				}
		  				if (unionWorkCode === 2 && groupBySize === 2) {
		  					history.form.push({label: '组选10',className: classNames.c_006dfe})
		  				}
		  				if (unionWorkCode === 2 && groupBySize === 1) {
		  					history.form.push({label: '组选5',className: classNames.c_ff33ff})
		  				}
		  				break;
		  			}
		  			// 4星
		  			case 4: {
		  				this.title = '四星组态';
		  				if (unionWorkCode === 4) {
		  					history.form.push({label: '组选24',className: classNames.c_7c73ff})
		  				}
		  				if (unionWorkCode === 3) {
		  					history.form.push({label: '组选12',className: classNames.c_1291bb})
		  				}
		  				if (unionWorkCode === 2 && groupBySize === 2) {
		  					history.form.push({label: '组选6',className: classNames.c_229e6d})
		  				}
		  				if (unionWorkCode === 2 && groupBySize === 1) {
		  					history.form.push({label: '组选4',className: classNames.c_cc8b1e})
		  				}
		  				break;
		  			}
		  			// 3星
		  			case 3: {
		  				this.title = '三星组态';
		  				if (unionWorkCode === 3) {
		  					history.form.push({label: '组六',className: classNames.c_0b9fb9})
		  				}
		  				if (unionWorkCode === 2) {
		  					history.form.push({label: '组三',className: classNames.c_fc5d50})
		  				}
		  				break;
		  			}
		  		}
		  	}.bind(this))
		    R.next();
		  }
		},
		// 和值
		{
			priority: 79000,
			condition: function(R) {
		    R.when( _.includes(this.ruleSuite.rules, 'SUM') );
		  },
		  consequence: function(R) {
		  	this.title = '和值';
		  	const methodName = _.trim(this.currentMethod.categoryName + this.currentMethod.methodName);
				_.each(this.historyCodes, function(history){
		  		const unionWorkCode = _.union(history.workCode).length;
		  		const sum = _.sum(history.workCode);
					if(isNaN(sum)){
						history.form.push({label: '--', className: classNames.b_f8aa46});
						return;
					}
					if(_.includes(methodName, '直选和值')){
						history.form.push({label: sum, className: classNames.b_f8aa46});
						return;
					}
		  		if(unionWorkCode > 1 || history.workCode.length == 2){
						history.form.push({label: sum, className: classNames.b_f8aa46})
		  		}
				})
		    R.next();
		  }
		},
		// 大小单双
		{
			priority: 78000,
			condition: function(R) {
		    R.when( _.includes(this.ruleSuite.rules, 'SINGLE_DOUBLE') );
		  },
		  consequence: function(R) {
		  	const methodName = _.trim(this.currentMethod.categoryName + this.currentMethod.methodName);
		  	if (methodName == '大小单双总和' || _.includes(methodName, '和值')){
		  		this.title = '和值';
		  	}
		  	if (methodName == '大小单双前二') {
		  		this.title = '万位 千位';
		  	}
		  	if (methodName == '大小单双后二') {
		  		this.title = '十位 个位';
		  	}
		  	if (methodName == '大小单双前三') {
		  		this.title = '万位 千位 百位';
		  	}
		  	if (methodName == '大小单双后三') {
		  		this.title = '百位 十位 个位';
		  	}
		  	if (methodName == '大小单双中三') {
		  		this.title = '千位 百位 十位';
		  	}
		  	if (_.includes(methodName, '大小个数') || _.includes(methodName, '单双个数')) {
		  		this.title = '形态';
		  	}
				_.each(this.historyCodes, function(history){

					const sum = _.sum(history.workCode);

					if(!isNaN(sum)){
						if (methodName == '大小单双总和') {
							if (sum > 22  && !isNaN(sum)) {
								history.form.push({label: '大', className: classNames.c_f95016})
							}else{
								history.form.push({label: '小', className: classNames.c_476efe})
							}

							if (sum % 2 == 1  && !isNaN(sum)) {
								history.form.push({label: '单', className: classNames.c_f95016})
							}else{
								history.form.push({label: '双', className: classNames.c_476efe})
							}
						}

						if (_.includes(methodName, '和值') && !isNaN(sum)) {
							if(methodName == '大小单双五星和值'){
								if (sum > 22){
									history.form.push({label: '大', className: classNames.c_f95016})
								}else{
									history.form.push({label: '小', className: classNames.c_476efe})
								}
							}else{
								if (sum > 13) {
									history.form.push({label: '大', className: classNames.c_f95016})
								}else{
									history.form.push({label: '小', className: classNames.c_476efe})
								}
							}

							if (sum % 2 == 1) {
								history.form.push({label: '单', className: classNames.c_f95016})
							}else{
								history.form.push({label: '双', className: classNames.c_476efe})
							}
						}
					}else{
						history.form.push({label: '--', className: classNames.c_ff0000})
					}

					if (methodName != '大小单双总和' && !_.includes(methodName, '和值') && !_.includes(methodName, '大小个数') && !_.includes(methodName, '单双个数')) {
						_.each(history.workCode, function(item, index){
							if(!isNaN(item)){
									if (item > 4) {
										history.form.push({label: '大', className: classNames.c_f95016})
									}else{
										history.form.push({label: '小', className: classNames.c_476efe})
									}
									// 单双
									if (item % 2 == 1) {
										history.form.push({label: '单', className: classNames.c_f95016})
									}else{
										history.form.push({label: '双', className: classNames.c_476efe})
									}
									if (history.workCode.length > (index + 1)) {
										history.form.push({label: ' ', className: 'empty'})
									}
							}else{
								history.form.push({label: ' ', className: 'empty'})
				  			history.form.push({label: '--', className: classNames.c_ff0000})
							}
						})
					}

					if (_.includes(methodName, '大小个数')) {
						var bigN = 0, smallN = 0;
						_.each(history.workCode, function(item, index){
							if(!isNaN(item)){
								if (item > 4) {
									bigN += 1;
								}else{
									smallN += 1;
								}
							}else{
				  			history.form.push({label: '--', className: classNames.c_ff0000})
							}
						})

						if(bigN == 0){
							history.form.push({label: '全小', className: classNames.c_476efe})
						}
						if(smallN == 0){
							history.form.push({label: '全大', className: classNames.c_f95016})
						}
						if(bigN > 0 && smallN > 0){
							history.form.push({label: bigN+'大', className: classNames.c_f95016})
							history.form.push({label: smallN+'小', className: classNames.c_476efe})
						}
					}

					if (_.includes(methodName, '单双个数')) {
						var singleN = 0, doubleN = 0;
						_.each(history.workCode, function(item, index){
							if(!isNaN(item)){
								if (item % 2 == 1) {
									singleN += 1;
								}else{
									doubleN += 1;
								}
							}else{
				  			history.form.push({label: '--', className: classNames.c_ff0000})
							}
						})

						if(singleN == 0){
							history.form.push({label: '全双', className: classNames.c_476efe})
						}
						if(doubleN == 0){
							history.form.push({label: '全单', className: classNames.c_f95016})
						}
						if(singleN > 0 && doubleN > 0){
							history.form.push({label: singleN+'单', className: classNames.c_f95016})
							history.form.push({label: doubleN+'双', className: classNames.c_476efe})
						}
					}


				})
		    R.next();
		  }
		},
		// 直选跨度
		{
			priority: 77000,
			condition: function(R) {
		    R.when( _.includes(this.ruleSuite.rules, 'SPAN') );
		  },
		  consequence: function(R) {
		  	this.title = '直选跨度';
				_.each(this.historyCodes, function(history){
					const min = _.min(history.workCode);
					const max = _.max(history.workCode);
					history.form.push({label: isNaN(max-min) ? '-' : max-min, className: classNames.b_f8aa46})
				})
		    R.next();
		  }
		},
		// 和值尾数
		{
			priority: 76000,
			condition: function(R) {
		    R.when( _.includes(this.ruleSuite.rules, 'SUM_TAIL_NUM') );
		  },
		  consequence: function(R) {
		  	this.title = '和值尾数';
				_.each(this.historyCodes, function(history){
					const sum = _.sum(history.workCode);
					history.form.push({label: isNaN(sum%10) ? '-' : sum%10, className: classNames.b_f8aa46})
				})
		    R.next();
		  }
		},
		// 龙虎斗
		{
			priority: 75000,
			condition: function(R) {
		    R.when( _.includes(this.ruleSuite.rules, 'DRAGON_TIGER_PK') );
		  },
		  consequence: function(R) {
		  	this.title = '形态';
		  	const methodName = _.trim(this.currentMethod.categoryName + this.currentMethod.methodName);
				_.each(this.historyCodes, function(history){
					if(history.code==''){
		  			history.form.push({label: '--',className: classNames.c_ff0000})
		  		}
					if (history.workCode[0] - history.workCode[1] == 0) {
						history.form.push({label: '-', className: classNames.c_ff0000})
					}
					if (history.workCode[0] - history.workCode[1] > 0) {
						history.form.push({label: methodName == '龙虎斗玄麟斗' ? '玄' : '龙', className: classNames.b_ff0000})
					}
					if (history.workCode[0] - history.workCode[1] < 0) {
						history.form.push({label: methodName == '龙虎斗玄麟斗' ? '麟' : '虎', className: classNames.b_4c8bda})
					}
				})
		    R.next();
		  }
		},
		// 百家乐庄闲和
		{
			priority: 74000,
			condition: function(R) {
		    R.when( _.includes(this.ruleSuite.rules, 'BACCARAT_1') );
		  },
		  consequence: function(R) {
		  	this.title = '形态';
				_.each(this.historyCodes, function(history){
					if(history.code==''){
		  			history.form.push({label: '--',className: classNames.c_ff0000})
		  		}
					const result = ((history.workCode[0] + history.workCode[1]) % 10) - ((history.workCode[2] + history.workCode[3]) % 10);
					if (result > 0) {
						history.form.push({label: '庄', className: classNames.b_ff0000})
					}
					if (result == 0) {
						history.form.push({label: '和', className: classNames.b_008000})
					}
					if (result < 0) {
						history.form.push({label: '闲', className: classNames.b_4c8bda})
					}
				})
		    R.next();
		  }
		},
		// 百家乐对子
		{
			priority: 73000,
			condition: function(R) {
		    R.when( _.includes(this.ruleSuite.rules, 'BACCARAT_2') );
		  },
		  consequence: function(R) {
		  	this.title = '形态';
				_.each(this.historyCodes, function(history){
					if(history.code==''){
		  			history.form.push({label: '--',className: classNames.c_ff0000})
		  		}
					if (history.workCode[0] == history.workCode[1]) {
						history.form.push({label: '庄', className: classNames.b_ff0000})
					}
					if (history.workCode[2] == history.workCode[3]) {
						history.form.push({label: '闲', className: classNames.b_4c8bda})
					}
				})
		    R.next();
		  }
		},
		// 百家乐豹子
		{
			priority: 72000,
			condition: function(R) {
		    R.when( _.includes(this.ruleSuite.rules, 'BACCARAT_3') );
		  },
		  consequence: function(R) {
		  	this.title = '形态';
				_.each(this.historyCodes, function(history){
					if(history.code==''){
		  			history.form.push({label: '--',className: classNames.c_ff0000})
		  		}
					if (_.chain(history.workCode).take(3).union().value().length == 1) {
						history.form.push({label: '庄', className: classNames.b_ff0000})
					}
					if (_.chain(history.workCode).slice(2).union().value().length == 1) {
						history.form.push({label: '闲', className: classNames.b_4c8bda})
					}
				})
		    R.next();
		  }
		},
		// 百家乐天王
		{
			priority: 71000,
			condition: function(R) {
		    R.when( _.includes(this.ruleSuite.rules, 'BACCARAT_4') );
		  },
		  consequence: function(R) {
		  	this.title = '形态';
				_.each(this.historyCodes, function(history){
					if(history.code==''){
		  			history.form.push({label: '--',className: classNames.c_ff0000})
		  		}
					if (_.includes([8,9], (history.workCode[0] + history.workCode[1]) % 10)) {
						history.form.push({label: '庄', className: classNames.b_ff0000})
					}
					if (_.includes([8,9], (history.workCode[2] + history.workCode[3]) % 10)) {
						history.form.push({label: '闲', className: classNames.b_4c8bda})
					}
				})
		    R.next();
		  }
		},
		// 全5中1
		{
			priority: 70000,
			condition: function(R) {
		    R.when( _.includes(this.ruleSuite.rules, '5IN1') );
		  },
		  consequence: function(R) {
		  	this.title = '形态';
				_.each(this.historyCodes, function(history){
					if(history.code==''){
		  			history.form.push({label: '--',className: classNames.c_ff0000})
		  		}
					const unionWorkCode = _.union(history.workCode).length;
		  		const groupBySize = _.filter(_.groupBy(history.workCode), (item) => item.length > 1).length;
		  		if (unionWorkCode === 1 && history.code!='') {
		  			history.form.push({label: '组选1',className: classNames.c_ff0000})
		  		}
		  		if (unionWorkCode === 2 && groupBySize === 1) {
		  			history.form.push({label: '组选5',className: classNames.c_ff33ff})
		  		}
		  		if (unionWorkCode === 2 && groupBySize === 2) {
		  			history.form.push({label: '组选10',className: classNames.c_006dfe})
		  		}
		  		if (unionWorkCode === 3 && groupBySize === 1) {
		  			history.form.push({label: '组选20',className: classNames.c_cc8b1e})
		  		}
		  		if (unionWorkCode === 3 && groupBySize === 2) {
		  			history.form.push({label: '组选30',className: classNames.c_229e6d})
		  		}
		  		if (unionWorkCode === 4 && groupBySize === 1) {
		  			history.form.push({label: '组选60',className: classNames.c_1291bb})
		  		}
		  		if (unionWorkCode === 5) {
		  			history.form.push({label: '组选120',className: classNames.c_7c73ff})
		  		}
				})
		    R.next();
		  }
		},
		// 快三通用
		{
			priority: 69000,
			condition: function(R) {
		    R.when( _.includes(this.ruleSuite.rules, 'K3_GENERAL') );
		  },
		  consequence: function(R) {
		  	this.title = '形态';
		  	_.each(this.historyCodes, function(history){
		  		const unionWorkCode = _.union(history.workCode).length;
		  		switch (unionWorkCode){
		  			case 1: {
		  				history.form.push({label: '三同号',className: classNames.c_cc8b1e})
		  				break;
		  			}
		  			case 2: {
		  				history.form.push({label: '二同号',className: classNames.c_006dfe})
		  				break;
		  			}
		  			case 3: {
		  				history.form.push({label: '三不同',className: classNames.c_229e6d})
		  				break;
		  			}
		  		}
		  	})
		    R.next();
		  }
		},
		// 快三连号
		{
			priority: 68000,
			condition: function(R) {
		    R.when( _.includes(this.ruleSuite.rules, 'K3_SERIAL_NO') );
		  },
		  consequence: function(R) {
		  	this.title = '形态';
		  	_.each(this.historyCodes, function(history){
		  		 if (history.workCode[0] + 1 == history.workCode[1] && history.workCode[1] + 1 == history.workCode[2]) {
		  		 		history.form.push({label: '三连号',className: classNames.c_7c73ff})
		  		 }else{
		  		 		history.form.push({label: '-',className: classNames.c_ff0000})
		  		 }
		  	})
		    R.next();
		  }
		},
		//PK10单双
		{
			priority: 67000,
			condition: function(R) {
		    R.when( _.includes(this.ruleSuite.rules, 'PK10_SINGLE_DOUBLE') );
		  },
		  consequence: function(R) {
		  	this.title = '形态';
		  	_.each(this.historyCodes, function(history){
		  		_.each(history.workCode, function(item, index){
						// 大小
						if (Number(item) > 5) {
							history.form.push({label: '大', className: classNames.c_f95016})
						}else{
							history.form.push({label: '小', className: classNames.c_476efe})
						}
						// 单双
						if (Number(item) % 2 == 0) {
							history.form.push({label: '双', className: classNames.c_476efe})
						}else{
							history.form.push({label: '单', className: classNames.c_f95016})
						}
					})
		  	})
		    R.next();
		  }
		},
		//牛牛
		{
			priority: 66000,
			condition: function(R) {
		    R.when( _.includes(this.ruleSuite.rules, 'NIUNIU') );
		  },
		  consequence: function(R) {
		  	this.title = '牛牛形态';
		  	_.each(this.historyCodes, function(history, index){
			  	const comArr = combinatorics.combination(history.workCode, 3).toArray();
			  	const niuArr = _.chain(comArr).filter((item) => _.sum(item) % 10 == 0).take(1).value();

			  	if(niuArr == ''){
						history.form.push({label: '无牛', className: classNames.c_476efe});
						history.displayCode = _.map(history.workCode, (item) => ({codes: item.toString(), className: 'disabled'}))
						return;
			  	}

			  	let startIndex = 0, prevItem=[], arrIndex;
			  	const niuIndex = _.map(niuArr[0], function(item){
			  		_.includes(prevItem, item) ? startIndex = 1+arrIndex : null;
			  		arrIndex = _.indexOf(history.workCode, item, startIndex);
			  		prevItem.push(item);
			  		return arrIndex;
			  	});
			  	const niuNum = _.chain(niuArr).map((item) => (_.sum(history.workCode) - _.sum(item))%10 ).uniq().value()[0];

			  	if(niuNum == 0){
						history.form.push({label: '牛牛', className: classNames.c_f95016})
			  	}else{
						history.form.push({label: '牛', className: classNames.c_476efe}, {label: niuNum, className: classNames.c_f95016})
			  	}

					history.form.push({label: ' ', className: 'empty'})

					if(niuNum > 5 || niuNum == 0){
						history.form.push({label: '牛', className: classNames.c_476efe}, {label: '大', className: classNames.c_f95016})
					}else{
						history.form.push({label: '牛', className: classNames.c_476efe}, {label: '小', className: classNames.c_f95016})
					}

					history.form.push({label: ' ', className: 'empty'})

					if(niuNum % 2 == 1){
						history.form.push({label: '牛', className: classNames.c_476efe}, {label: '单', className: classNames.c_f95016})
					}else{
						history.form.push({label: '牛', className: classNames.c_476efe}, {label: '双', className: classNames.c_f95016})
					}

					history.displayCode = _.map(history.workCode, (v, i) => ({codes: v.toString(), className: _.includes(niuIndex, i) ? 'active' : 'disabled'}))
		  	})
		    R.next();
		  }
		}
	]
}